import script from "./SelectWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectWorkspaceModal.vue?vue&type=style&index=0&id=47b1d33c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b1d33c"]])

export default __exports__